/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
/* eslint-disable import/extensions */
/* eslint-disable no-use-before-define */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
/* eslint-disable no-mixed-operators */
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { updateDobStatus } from '../../api/agentic/dobStatusApi.js';
import { updateRecordRole } from '../../api/agentic/duplicateApi';
import { ReactComponent as ApplicationStatusIcon } from "../../assets/logos/ApplicationStatusAgent.svg";
import { ReactComponent as BenefitAgentIcon } from "../../assets/logos/BenefitAgent.svg";
import { ReactComponent as DocumentAgentIcon } from "../../assets/logos/DocumentQualityAgent.svg";
import { ReactComponent as EligibilityAgentIcon } from "../../assets/logos/EligibilityReviewAgent.svg";
import { ReactComponent as ReviewAgentIcon } from "../../assets/logos/IntakeReviewAgent.svg";
import { documentCaseColumns, documentQualityColumns } from '../../config/agentic/documentQualityConfig';
import { duplicateConfig } from '../../config/agentic/duplicateConfig';
import { KEY_INSIGHTS_CONFIG } from '../../config/agentic/keyInsightsConfig';
import { AGENT_METRICS } from '../../config/agentic/metricsConfig.js';
import { AGENT_NAME_TO_ID, AGENT_TYPES } from "../../constants/agentTypes";
import '../../styles/AppScreen.css';
import { agenticGet } from "../../utils/agenticApiClient";
import { convertFormattedDuration } from '../../utils/formateDate.js';
import {
  extractDuplicateComparableFields,
  extractPrimaryComparableFields,
  getFieldMatchLevel,
  getFirstNonEmpty,
  getReportTitle,
  mapApiDuplicatesToTableRows,
  mapDocumentRows,
  mapInputRecordToPrimaryRow,
  sortWeekDays
} from '../../utils/helper.js';
import ActionCard from '../sharedComponents/ActionCard';
import ActivityFeedCard from '../sharedComponents/ActivityFeedCard';
import { transformApiResponse } from '../sharedComponents/agents/applicationHistoryNormalizer.js';
import AppHeader from '../sharedComponents/AppHeader';
import ApplicationsBarChart from '../sharedComponents/ApplicationsBarChart';
import ApplicationTable from '../sharedComponents/BenefitAgent/ApplicationTable';
import CaseStatusCard from '../sharedComponents/CaseStatusCard.jsx';
import ConfirmDialog from "../sharedComponents/ConfirmDialog.tsx";
import DisasterNavBar from '../sharedComponents/DisasterNavBar';
import DocumentViewerModal from '../sharedComponents/DocumentViewerModal.jsx';
import DuplicateSection from '../sharedComponents/DuplicateSection';
import DuplicatesLineChart from '../sharedComponents/DuplicatesLineChart';
import EmptyBenefitsState from '../sharedComponents/EmptyBenefitsState.jsx';
import IncomingApplication from '../sharedComponents/IncomingApplication.jsx';
import IntakeAgentPanel from '../sharedComponents/IntakeAgent/IntakeAgentPanel';
import KeyInsightsCard from '../sharedComponents/KeyInsightsCard';
import PageHeader from '../sharedComponents/PageHeader';
import EligibilityReport from '../sharedComponents/Report/ElligibilityReport.jsx';
import ReportLegend from '../sharedComponents/ReportLegend';
import ReportSummary from '../sharedComponents/ReportSummary';

const ReliefManScreen = ({
  logedInUserMail, entries,
  actionItems,
  // stats,
  agentName, pageTitle,
  title, subtitle,
}) => {
  const [isAgentPanelOpen, setIsAgentPanelOpen] = useState(false);
  const [defaultMsg, setDefaultMsg] = useState(null);
  const [docsNeedingCorrection, setDocsNeedingCorrection] = useState([]);
  const [acceptableDocs, setAcceptableDocs] = useState([]);
  const [metricsResponse, setMetricsResponse] = useState(null);
  const [metricsLoading, setMetricsLoading] = useState(true);
  const PAGE_SIZE = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const location = useLocation();
  const reportData = location.state?.reportData;
  const [duplicateApplications, setDuplicateApplications] = useState([]);
  const [openDoc, setOpenDoc] = useState(null);
  const isBenefitsReport = reportData?.agentId === "benefit-agent-b1";
  const [selectedPrimary, setSelectedPrimary] = useState(null);
  const [benefitsData, setBenefitsData] = useState({
    SBA: { related: [], unrelated: [] },
    FEMA: { related: [], unrelated: [] },
    NFIP: { related: [], unrelated: [] },
  });
  const [caseStatusItems, setCaseStatusItems] = useState([]);
  const [caseStatusCount, setCaseStatusCount] = useState(0);
  const [caseStatusLoading, setCaseStatusLoading] = useState(false);
  const [transformedEntries, settransformedEntries] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const agentId = reportData?.agentId;
  const isApplicationStatusAgent = agentName === AGENT_TYPES.APPLICATION_STATUS;
  const keyInsightAgentId = AGENT_NAME_TO_ID[agentName];
  const isDocumentAgent = agentId === "DocumentProcessingAgent";
  const isDuplicateAgent = agentId === "review-intake-a1" && !isApplicationStatusAgent;
  const isBenefitsAgent = agentId === "benefit-agent-b1";
  const isEligibilityAgent = agentName === AGENT_TYPES.ELIGIBILITY_REVIEW;
  const [potentialDuplicates, setPotentialDuplicates] = useState([]);

  const duplicateComparable = extractDuplicateComparableFields(potentialDuplicates);
  const [primaryApplications, setPrimaryApplications] = useState([]);

  const primaryApplicationData = primaryApplications;
  const [reportConfig, setReportConfig] = useState({
    legendTitle: '',
    summary: reportData?.summary,
    primaryData: primaryApplicationData,
    columns: duplicateConfig.getColumns({ isBenefitsAgent, showAction: !isBenefitsAgent }),
  });

  useEffect(() => {
    const reportType = isApplicationStatusAgent
      ? 'APPLICATION_STATUS'
      : isBenefitsReport
        ? 'BENEFITS'
        : 'DUPLICATE';
    const title = getReportTitle({ reportType, reportData });

    setReportConfig((prev) => ({
      ...prev,
      legendTitle: title,
    }));
  }, [reportData, isApplicationStatusAgent, isBenefitsReport]);

  useEffect(() => {
    if (!reportData?.input_record) return;

    const mappedPrimary = mapInputRecordToPrimaryRow(reportData.input_record, duplicateComparable);

    setPrimaryApplications([mappedPrimary]);
  }, [reportData?.input_record]);

  const fetchApplicationHistory = async (caseId) => {
    try {
      const response = await agenticGet(`/application-history?case_id=${caseId}`);
      const transformedEntries = transformApiResponse(response.data);
      settransformedEntries(transformedEntries); // Set transformed entries data
    } catch (error) {
      console.error("Error fetching programs:", error);
    }
  };
  const paginate = (data) => {
    if (!Array.isArray(data)) return [];
    const start = (currentPage - 1) * PAGE_SIZE;
    return data.slice(start, start + PAGE_SIZE);
  };

  const comparedDuplicates = useMemo(() => {
    const primary = primaryApplications[0];
    if (!primary) return potentialDuplicates;

    return potentialDuplicates.map((row) => ({
      ...row,
      _compare: {
        firstName: getFieldMatchLevel(primary.firstName, row.firstName),
        lastName: getFieldMatchLevel(primary.lastName, row.lastName),
      },
    }));
  }, [potentialDuplicates, primaryApplications]);

  const applicationData = [
    {
      caseId: "2034",
      appStatus: "For Benefit Search",
      lastUpdate: "2025-10-01",
      updateBy: "Lois Griffin",
      assignedTo: "Lois Griffin",
      Notes: "Assigned for benefit search; insurance status unknown",
    },
    {
      caseId: "2035",
      appStatus: "For Benefit Search",
      lastUpdate: "2025-10-01",
      updateBy: "John Doe",
      assignedTo: "John Doe",
      Notes: "Benefit check to confirm external assistance",
    },
    {
      caseId: "2036",
      appStatus: "For Benefit Search",
      lastUpdate: "2025-10-01",
      updateBy: "Sam Smith",
      assignedTo: "John Doe",
      Notes: "DOB check assigned, applicant reported FEMA registration",
    },
    {
      caseId: "2037",
      appStatus: "For Benefit Search",
      lastUpdate: "2025-10-01",
      updateBy: "Sam Smith",
      assignedTo: "John Doe",
      Notes: "Routed for benefit verification",
    },

  ];

  const isReviewAgentScreen = title === "Duplicate Report" || agentName === "Intake Review Agent" || agentName === "Document Quality Agent" || agentName === "Eligibility Review Agent";

  const handleMarkDuplicate = async (selectedRows) => {
    try {
      await Promise.all(
        selectedRows.map((row) => updateRecordRole({
          caseId: row.caseId,
          recordRole: "DUPLICATE",
        })),
      );

       setDuplicateApplications((prev) => {
        const newRows = selectedRows.filter(
          (selected) =>
            !prev.some((existing) => existing.caseId === selected.caseId),
        );

        return [...prev, ...newRows];
      });

      setPotentialDuplicates((prev) => prev.filter(
        (row) => !selectedRows.some(
          (selected) => selected.caseId === row.caseId,
        ),
      ));
      toast.success("Application marked as duplicate successfully");
    } catch (error) {
      console.error("Failed to mark duplicate:", error);
      toast.error("Failed to mark duplicate. Please try again.");
    }
  };

  const handleMarkRelated = async (selectedRows, { status, source }) => {
    try {
      // Update backend
      await Promise.all(
        selectedRows.map((row) => updateDobStatus({
          matchedCaseId: row.caseId,
          sourceCaseId: reportData.input_record.CaseID,
          status,
        })),
      );

      setBenefitsData((prev) => {
        const prevSource = prev[source];
        let related = [...prevSource.related];
        let unrelated = [...prevSource.unrelated];

        if (status === "RELATED") {
          // Move selected rows from related → unrelated
          selectedRows.forEach((row) => {
            // Remove from related if exists
            unrelated = unrelated.filter((r) => r.caseId !== row.caseId);
            // Add to unrelated if not already there
            if (!unrelated.some((r) => r.caseId === row.caseId)) {
              related.push(row);
            }
          });
        } else if (status === "UNRELATED") {
          // Move selected rows from unrelated → related
          selectedRows.forEach((row) => {
            // Remove from unrelated if exists
            related = related.filter((r) => r.caseId !== row.caseId);
            // Add to related if not already there
            if (!related.some((r) => r.caseId === row.caseId)) {
              unrelated.push(row);
            }
          });
        }

        return { ...prev, [source]: { related, unrelated } };
      });

      toast.success(`Marked as ${status.toLowerCase()}`);
    } catch (error) {
      console.error(error);
      toast.error(`Failed to mark as ${status}`);
    }
  };

  useEffect(() => {
    if (!reportData) return;

    const matches = reportData?.matches
      || reportData?.output_text?.matches
      || reportData?.output_text?.data_sources_matches || [];
    if (isDuplicateAgent) {
      const statusToSetter = {
        POTENTIAL_DUPLICATE: setPotentialDuplicates,
        PRIMARY: setPrimaryApplications,
        DUPLICATE: setDuplicateApplications,
      };

      Object.entries(statusToSetter).forEach(([status, setter]) => {
        const caseIds = Object.entries(reportData?.outputText?.case_status || reportData?.case_status || {})
          .filter(([_, caseStatus]) => caseStatus === status)
          .map(([caseId]) => caseId);

        const filteredMatches = matches.filter((match) => caseIds.includes(match.case_id));

        let mappedRows;

        if (status === "PRIMARY") {
          // For PRIMARY, use the first record or fallback to input_record
          const primaryRecord = filteredMatches[0]?.record?.full_candidate_record || reportData?.input_record;
          mappedRows = primaryRecord
            ? [mapInputRecordToPrimaryRow(primaryRecord, duplicateComparable)]
            : [];
        } else {
          // For non-PRIMARY statuses
          mappedRows = mapApiDuplicatesToTableRows(filteredMatches) || [];

          // Ensure input_record is added if its CaseID is in caseIds and it's not already in mappedRows
          const inputRecordCaseID = reportData?.input_record?.CaseID;

          const isCaseIdInCaseIds = caseIds.includes(inputRecordCaseID);

          const isAlreadyInMappedRows = mappedRows.some(
            (row) => row.CaseID === inputRecordCaseID,
          );

          if (isCaseIdInCaseIds && !isAlreadyInMappedRows) {
            // Push input_record as a table row
            mappedRows.push(...mapApiDuplicatesToTableRows([{ raw: reportData.input_record }]));
          }
        }

        setter(mappedRows);
      });
    } else {
      setPotentialDuplicates(
        mapApiDuplicatesToTableRows(matches),
      );
    }
  }, [reportData]);

  // seprating this useEffect for future conversion inn seprate page.
  useEffect(() => {
    if (!isBenefitsReport) return;

    const caseStatusMap = reportData?.outputText?.case_status || reportData?.case_status || {};

    const buckets = {
      SBA: { related: [], unrelated: [] },
      FEMA: { related: [], unrelated: [] },
      NFIP: { related: [], unrelated: [] },
    };

    comparedDuplicates.forEach((row) => {
      const status = caseStatusMap[row.caseId];
      if (!status) return;

      const statusKey = status.toLowerCase(); // 'related' | 'unrelated'

      if (row.dataSource === "SBA_HOME" || row.dataSource === "SBA_BUSINESS") {
        buckets.SBA[statusKey]?.push(row);
      }
      if (row.dataSource === "FEMA") {
        buckets.FEMA[statusKey]?.push(row);
      }
      if (row.dataSource === "NFIP") {
        buckets.NFIP[statusKey]?.push(row);
      }
    });

    const shallowEqual = (arr1, arr2) => arr1?.length === arr2?.length && arr1?.every((item, i) => item === arr2[i]);

    setBenefitsData((prev) => {
      const sbaChanged = !shallowEqual(prev.SBA?.related, buckets.SBA?.related)
        || !shallowEqual(prev.SBA?.unrelated, buckets.SBA?.unrelated);

      const femaChanged = !shallowEqual(prev.FEMA?.related, buckets.FEMA?.related)
        || !shallowEqual(prev.FEMA?.unrelated, buckets.FEMA?.unrelated);

      const nfipChanged = !shallowEqual(prev.NFIP?.related, buckets.NFIP?.related)
        || !shallowEqual(prev.NFIP?.unrelated, buckets.NFIP?.unrelated);

      if (!sbaChanged && !femaChanged && !nfipChanged) return prev;

      return buckets;
    });
  }, [reportData, comparedDuplicates, isBenefitsReport]);

  /* ================= CASE ROW ================= */
  const mapDocumentCaseRow = (apiCase) => ({
    caseId: apiCase?.caseId || apiCase?.case_id || "-",
    submitDate: apiCase?.submitted_on || "-",
    origin: apiCase?.origin || "-",
    firstName: apiCase?.applicant_first_name || "-",
    lastName: apiCase?.applicant_last_name || "-",
    caseManager: apiCase?.case_manager || "-",
    updatedAt: apiCase?.updated_at || "-",
    notes: "Document quality check completed",
  });

  useEffect(() => {
    if (isDocumentAgent && reportData?.documentRows?.length) {
      const mapped = mapDocumentRows(reportData.documentRows);

      setDocsNeedingCorrection(
        mapped.filter((row) => !row.notes.startsWith("Acceptable")),
      );

      setAcceptableDocs(
        mapped.filter((row) => row.notes.startsWith("Acceptable")),
      );
    }
  }, [reportData, isDocumentAgent]);

  const handleMarkDocAcceptable = (docs) => {
    setAcceptableDocs((prev) => [...prev, ...docs]);

    setDocsNeedingCorrection((prev) => prev.filter(
      (row) => !docs.some(
        (selected) => selected.documentId === row.documentId,
      ),
    ));
  };

  const handleMarkDocNotAcceptable = (docs) => {
    setDocsNeedingCorrection((prev) => [...prev, ...docs]);

    setAcceptableDocs((prev) => prev.filter(
      (row) => !docs.some(
        (selected) => selected.documentId === row.documentId,
      ),
    ));
  };

  useEffect(() => {
    if (!keyInsightAgentId) return;

    const metricsConfig = AGENT_METRICS[keyInsightAgentId];

    // STATIC → no API call
    if (metricsConfig?.type === "static") {
      setMetricsLoading(false);
      setMetricsResponse(null);
      return;
    }

    if (!metricsConfig?.api) {
      setMetricsLoading(false);
      return;
    }

    const fetchMetrics = async () => {
      try {
        setMetricsLoading(true);
        const data = await agenticGet(metricsConfig.api);
        setMetricsResponse(data);
      } catch (err) {
        console.error("Metrics API error:", err);
        setMetricsResponse(null);
      } finally {
        setMetricsLoading(false);
      }
    };

    fetchMetrics();
  }, [keyInsightAgentId]);

  const stats = (() => {
    if (!keyInsightAgentId || !AGENT_METRICS[keyInsightAgentId]) return [];

    const config = AGENT_METRICS[keyInsightAgentId];

    // STATIC METRICS
    if (config.type === "static") {
      const data = typeof config.getData === "function"
        ? config.getData()
        : config.data;

      return data
        .map((stat) => {
          const ui = KEY_INSIGHTS_CONFIG[stat.iconKey];
          if (!ui) return null;

          return {
            title: stat.title ?? ui.title,
            value: stat.value,
            hint: stat.hint,
            label: stat.label,
            icon: ui.icon,
            labelIcon: stat.labelIcon ?? ui.labelIcon,
          };
        })
        .filter(Boolean);
    }

    // API METRICS
    if (config.api && metricsResponse) {
      return config
        .mapResponse(metricsResponse)
        .map((stat) => {
          const ui = KEY_INSIGHTS_CONFIG[stat.iconKey];
          if (!ui) return null;
          return {
            title: stat.title ?? ui.title,
            value: stat.value,
            hint: stat.hint,
            label: stat.label,
            icon: ui.icon,
            labelIcon: stat.labelIcon ?? ui.labelIcon,
          };
        })
        .filter(Boolean);
    }

    return [];
  })();

  useEffect(() => {
    if (!isBenefitsAgent) return;
    if (primaryApplications.length > 0) return;
    if (!reportData?.matches?.length) return;

    const first = reportData.matches[0];
    const record = first?.matches?.raw;

    if (!record) return;

    setPrimaryApplications([{
      caseId: record.CaseID || "-",
      submitDate: record.CaseSubmitDate || "-",
      origin: "Benefits",
      firstName: record.ApplicantFirstName || "-",
      lastName: record.ApplicantLastName || "-",
      caseManager: record.CaseManager || "-",
      notes: "Primary application inferred from Benefits match",
      details: [],
    }]);
  }, [isBenefitsAgent, reportData, primaryApplications]);

  const handleTagPrimary = async (row, isDuplicate = true) => {
    try {
      if (primaryApplications?.length > 0) {
        setCurrentRow(row);
        setOpenDialog(true);
        setIsDuplicate(isDuplicate);
      }
    } catch (error) {
      console.error("Failed to tag primary:", error);
      toast.error("Failed to mark as primary.");
    }
  };

  const proceedWithTagging = async (row) => {
    try {
      await updateRecordRole({
        caseId: row.caseId,
        recordRole: "PRIMARY",
      });

      await updateRecordRole({
        caseId: primaryApplications[0].caseId,
        recordRole: isDuplicate ? "DUPLICATE" : "POTENTIAL_DUPLICATE",
      });

      let primaryRow;

      const fullRecordMatch = reportData?.matches?.find(
        (m) => m.record?.full_candidate_record?.CaseID === row.caseId,
      );

      if (fullRecordMatch?.record?.full_candidate_record) {
        primaryRow = mapInputRecordToPrimaryRow(
          fullRecordMatch.record.full_candidate_record,
          duplicateComparable,
        );
      } else if (
        reportData?.input_record
        && reportData.input_record.CaseID === row.caseId
      ) {
        primaryRow = mapInputRecordToPrimaryRow(
          reportData.input_record,
          duplicateComparable,
        );
      } else {
        primaryRow = {
          caseId: row.caseId,
          submitDate: row.submitDate,
          origin: row.origin,
          firstName: row.firstName,
          lastName: row.lastName,
          caseManager: row.caseManager,
          notes: "Tagged as Primary from duplicates",
          details: [],
        };
      }
      const matchedRow = reportData?.matches?.find((match) => match.case_id === primaryApplications[0].caseId);

      const mappedRows = matchedRow
        ? mapApiDuplicatesToTableRows([matchedRow])
        : mapApiDuplicatesToTableRows([{ raw: reportData.input_record }]);

      if (isDuplicate) {
        setDuplicateApplications((prev) => [
          ...prev.filter((item) => item.caseId !== row.caseId),
          ...mappedRows,
        ]);
      } else {
        setPotentialDuplicates((prev) => [
          ...prev.filter((item) => item.caseId !== row.caseId),
          ...mappedRows,
        ]);
      }
      setPrimaryApplications((prev) => {
        const existingPrimary = prev[0];
        const exists = prev.some((item) => item.caseId === primaryRow.caseId);

        if (exists) return prev;
        return [primaryRow];
      });

      setSelectedPrimary(primaryRow);
      toast.success("Marked as primary successfully!");
    } catch (error) {
      console.error("Failed to tag primary:", error);
      toast.error("Failed to mark as primary.");
    }
  };

  // Confirm Dialog Close Handler
  const handleDialogClose = () => {
    setOpenDialog(false); // Close the dialog without doing anything
  };

  // Confirm Dialog Confirm Handler (Execute the tagging after confirmation)
  const handleDialogConfirm = async () => {
    if (currentRow) {
      if (primaryApplications.length > 0) {
        // Move the old primary to potentialDuplicates or duplicateApplications based on the condition
        setPrimaryApplications((prev) => prev.filter((item) => item.caseId !== currentRow.caseId));
      }

      // Proceed with tagging the new primary
      await proceedWithTagging(currentRow);

      setOpenDialog(false); // Close the dialog after confirming
    }
  };

  const hasMetrics = Boolean(keyInsightAgentId && AGENT_METRICS[keyInsightAgentId]);

  const totalItems = Math.max(
    primaryApplicationData.length,
    potentialDuplicates.length,
    duplicateApplications.length,
  );

  const totalPages = Math.ceil(totalItems / PAGE_SIZE);
  const isDocumentQualityReport = location.pathname === "/documentQuality-report"
    && isDocumentAgent;

  const primaryComparable = isBenefitsAgent && primaryApplications[0]
    ? extractPrimaryComparableFields(primaryApplications[0])
    : selectedPrimary
      ? extractPrimaryComparableFields(selectedPrimary)
      : {};

  const benefitsColumns = duplicateConfig.getColumns({
    isBenefitsAgent: true,
    showAction: false,
  });

  const chartData = metricsResponse?.application_intake?.map((item) => ({
    day: item.weekday,
    value: item.count,
  })) || [];

  const weeklyData = metricsResponse?.weekly_performance?.map((item) => ({
    day: item.weekday,
    value: item.count,
  })) || [];

  const shouldHideDashboard = agentName === AGENT_TYPES.INTAKE_REVIEW_AGENT
    && title === "Duplicate Report";

  const shouldHideDashboardBenefit = agentName === "Benefits Agent" && title === "Benefits Report";

  const AGENT_ICON_MAP = {
    [AGENT_TYPES.APPLICATION_STATUS]: ApplicationStatusIcon,
    [AGENT_TYPES.ELIGIBILITY_REVIEW]: EligibilityAgentIcon,
    [AGENT_TYPES.DOCUMENT]: DocumentAgentIcon,
  };

  const getAgentIcon = () => {
    if (AGENT_ICON_MAP[agentName]) return AGENT_ICON_MAP[agentName];
    if (isReviewAgentScreen) return ReviewAgentIcon;
    return BenefitAgentIcon;
  };
  const Icon = getAgentIcon();
  const isApplicationStatusReport = location.pathname === "/application-status-report";
  const handleTrigger = (text) => {
    setDefaultMsg(`Check application status of ${text}`);
    setIsAgentPanelOpen(true);
  };

  const fetchCaseStatus = async (name) => {
    // TODO: Need to implement filter change on other agent pages as well
    if (!isApplicationStatusAgent) return;
    settransformedEntries([]);
    try {
      setCaseStatusLoading(true);

      const data = await agenticGet(`/latest-status?program_name=${encodeURIComponent(name)}`);
      const mappedItems = (data || []).map((item) => {
        const duration = item.status_duration || {};
        const formattedDuration = convertFormattedDuration(duration);

        return {
          text: item.case_id,
          duration: formattedDuration,
          status: item.note_type || "-",
          type: item.note_sub_type === "Inactive" ? "warning" : "",
        };
      });
      setCaseStatusItems(mappedItems || []);
      setCaseStatusCount(mappedItems.length);
    } catch (error) {
      console.error("Case Status API Error:", error);
    } finally {
      setCaseStatusLoading(false);
    }
  };

  const hasNextPage = (data = []) => {
    if (!Array.isArray(data)) return false;
    const nextPageStart = currentPage * PAGE_SIZE;
    return nextPageStart < data.length;
  };
  const duplicatePageData = comparedDuplicates;

  const benefitsPageData = getFirstNonEmpty([
    benefitsData.SBA.related,
    benefitsData.FEMA.related,
    benefitsData.NFIP.related,
    benefitsData.SBA.unrelated,
    benefitsData.FEMA.unrelated,
    benefitsData.NFIP.unrelated,
  ]);

  const combinedDocs = [
    ...docsNeedingCorrection.map((d) => ({ ...d, _type: "correction" })),
    ...acceptableDocs.map((d) => ({ ...d, _type: "acceptable" })),
  ];

  const paginatedCombinedDocs = paginate(combinedDocs);

  const paginatedCorrections = paginatedCombinedDocs.filter(
    (d) => d._type === "correction",
  );

  const paginatedAcceptable = paginatedCombinedDocs.filter(
    (d) => d._type === "acceptable",
  );

  const documentPageData = combinedDocs;
  useEffect(() => {
    setCurrentPage(1);
  }, [
    duplicatePageData.length,
    benefitsPageData.length,
    documentPageData.length,
  ]);

  return (
    <div className="chat-container">
      <ToastContainer position="top-right" autoClose={3000} />
      <DisasterNavBar logedInUserMail={logedInUserMail} />
      <div className="agentAppContainer">
        <div className={`main-wrapper ${isAgentPanelOpen ? "panel-open" : ""}`}>

          <div className="hello-trigger" onClick={() => setIsAgentPanelOpen(true)}>
            <Icon
              className="agent-icon"
              title="Chat with Agent"
              aria-label="Chat with Agent"
            />
          </div>
          <PageHeader
            title={title}
            subtitle={subtitle}
          />

          {!isDocumentQualityReport && !shouldHideDashboardBenefit
            && !shouldHideDashboard && (agentName === AGENT_TYPES.BENEFITS
              || agentName === AGENT_TYPES.INTAKE_REVIEW_AGENT
              || agentName === AGENT_TYPES.DOCUMENT || agentName === AGENT_TYPES.ELIGIBILITY_REVIEW) && !reportData && (

              <>
                <AppHeader title={pageTitle} />

                <div className="dashboard-row">

                  <div className="card-wrapper left">
                    <div className="card-title-outside">Action Items</div>
                    <ActionCard
                      count={26}
                      items={actionItems}
                      subText="Waiting for review"
                    />
                  </div>

                  <div className="card-wrapper right">
                    <div className="card-header-outside">
                      <div className="card-title-outside">Activity Feed</div>
                      <a href="#view" className="view-all-link">View All</a>
                    </div>
                    <ActivityFeedCard entries={entries} onAskAgent={(e) => setIsAgentPanelOpen(true)} />
                  </div>

                </div>
              </>
          )}
          {agentName === AGENT_TYPES.APPLICATION_STATUS && !isApplicationStatusReport && !reportData && (
            <>
              {' '}
              <AppHeader onProgramChange={(programName) => fetchCaseStatus(programName)} title={pageTitle} />
              {' '}

              <div className="dashboard-row application-status-wrap">

                <div className="card-wrapper left">
                  <div className="card-title-outside">Active Overdue Cases</div>
                  <CaseStatusCard
                    count={caseStatusLoading ? "..." : caseStatusCount}
                    items={caseStatusLoading ? [] : caseStatusItems}
                    subText="Total Overdue Cases"
                    handleSelection={(e) => {
                      fetchApplicationHistory(e);
                    }}
                  />
                </div>

                <div className="card-wrapper right">
                  <div className="card-header-outside">
                    <div className="card-title-outside">Case History</div>
                    <a href="#view" className="view-all-link">View All</a>
                  </div>
                  <ActivityFeedCard entries={transformedEntries} onAskAgent={(e) => handleTrigger(e)} />
                </div>

              </div>
            </>
          )}

          {!isDocumentQualityReport && hasMetrics && !shouldHideDashboard && !reportData && (
            <div className="dashboard-row">
              <div className="card-wrapper ki">
                <div className="card-title-outside">
                  {agentName === AGENT_TYPES.DOCUMENT
                    ? "Key Performance Metrics"
                    : "Key Insights"}
                </div>

                {!metricsLoading && (
                  <KeyInsightsCard agentName={agentName} stats={stats} />
                )}
              </div>
            </div>
          )}

          {(agentName === AGENT_TYPES.ELIGIBILITY_REVIEW) && !reportData && (
            <div className="dashboard-row">
              <div className="card-wrapper ki">
                <div className="card-title-outside">Incoming Applications</div>
                <div className="charts-row w-50">

                  <div className="chart-box">
                    <IncomingApplication
                      title="Received Applications by Month"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {(agentName === AGENT_TYPES.DOCUMENT) && !reportData && (
            <div className="dashboard-row">
              <div className="card-wrapper ki">
                <div className="card-title-outside">Document Verification Performance</div>
                <div className="charts-row w-50">

                  <div className="chart-box">
                    <IncomingApplication
                      title="Rejected Documents by Month"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {agentName !== AGENT_TYPES.DOCUMENT && hasMetrics && !shouldHideDashboard && !isEligibilityAgent && (
            <div className="dashboard-row">
              <div className="card-wrapper ki">
                <div className="card-title-outside">Weekly Intake Performance</div>
                <div className="charts-row">

                  <div className="chart-box">
                    <DuplicatesLineChart data={sortWeekDays(weeklyData)} />
                  </div>

                  <div className="chart-box">
                    <ApplicationsBarChart data={sortWeekDays(chartData)} />
                  </div>

                </div>
              </div>
            </div>
          )}
          {agentName === "Benefits Agent" && !shouldHideDashboardBenefit && (
            <div className="card-wrapper">
              <div className="card-title-outside">Applications</div>

              <ApplicationTable data={paginate(applicationData)} />
            </div>
          )}
          {reportData && (
            <>
              {isDuplicateAgent && (
                <>
                  <ReportLegend title={reportConfig.legendTitle} legends />

                  <ReportSummary summary={reportData?.summary} />

                  <DuplicateSection
                    title="Primary Application Details"
                    columns={duplicateConfig.primaryApplColumns}
                    data={paginate(primaryApplicationData)}
                    emptyComponent={(
                      <EmptyBenefitsState
                        title="No Application Found"
                      />
                    )}
                  />

                  <DuplicateSection
                    title="Potential Duplicates"
                    columns={reportConfig.columns}
                    data={paginate(comparedDuplicates)}
                    onTagPrimary={(row) => handleTagPrimary(row, false)}
                    onMarkDuplicate={handleMarkDuplicate}
                    showActions
                    actionLabel="Mark as Duplicate"
                    emptyComponent={(
                      <EmptyBenefitsState
                        title="No Potential Duplicates"
                      />
                    )}
                  />

                  <DuplicateSection
                    title="Duplicate Applications"
                    columns={reportConfig.columns}
                    data={paginate(duplicateApplications)}
                    onTagPrimary={(row) => handleTagPrimary(row, true)}
                    emptyComponent={(
                      <EmptyBenefitsState
                        title="No Duplicate Applications"
                      />
                    )}
                  />
                  <div className="global-pagination">
                    <button
                      className="nav-btn"
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage((p) => p - 1)}
                    >
                      &lt; Back
                    </button>

                    <button
                      className="nav-btn"
                      disabled={!hasNextPage(duplicatePageData)}
                      onClick={() => setCurrentPage((p) => p + 1)}
                    >
                      Next &gt;
                    </button>
                  </div>

                </>
              )}

              {isApplicationStatusAgent && (
                <>
                  <ReportLegend
                    title="Application Status Report"
                  />

                  <ReportSummary summary={reportData.summary} />

                </>
              )}
              {isEligibilityAgent && (
                <EligibilityReport reportData={reportData} />
              )}

              {isBenefitsAgent && (
                <>
                  <ReportLegend title={reportConfig.legendTitle} legends />

                  <ReportSummary summary={reportData?.summary} />

                  <DuplicateSection
                    title="Application Details"
                    columns={duplicateConfig.primaryApplColumns}
                    data={paginate(primaryApplications)}
                  />

                  <DuplicateSection
                    title="Potential SBA Benefits"
                    columns={benefitsColumns}
                    data={paginate(benefitsData?.SBA?.unrelated)}
                    showActions
                    actionLabel="Mark as Related"
                    onMarkDuplicate={(rows) => handleMarkRelated(rows, { status: "RELATED", source: "SBA" })}
                    emptyComponent={(
                      <EmptyBenefitsState
                        title="No Potential SBA Benefits"
                      />
                    )}
                  />

                  {benefitsData.SBA?.related?.length > 0 && (
                    <DuplicateSection
                      title="Confirmed SBA Benefits"
                      columns={benefitsColumns}
                      showActions
                      data={paginate(benefitsData.SBA?.related)}
                      actionLabel="Mark as Unrelated"
                      onMarkDuplicate={(rows) => handleMarkRelated(rows, { status: "UNRELATED", source: "SBA" })}
                    />
                  )}

                  <DuplicateSection
                    title="Potential FEMA Benefits"
                    columns={benefitsColumns}
                    data={paginate(benefitsData.FEMA?.unrelated)}
                    showActions
                    actionLabel="Mark as Related"
                    onMarkDuplicate={(rows) => handleMarkRelated(rows, { status: "RELATED", source: "FEMA" })}
                    emptyComponent={(
                      <EmptyBenefitsState
                        title="No Potential FEMA Benefits"
                      />
                    )}
                  />

                  {benefitsData.FEMA?.related?.length > 0 && (
                    <DuplicateSection
                      title="Confirmed FEMA Benefits"
                      columns={benefitsColumns}
                      data={paginate(benefitsData.FEMA?.related)}
                      showActions
                      actionLabel="Mark as Unrelated"
                      onMarkDuplicate={(rows) => handleMarkRelated(rows, { status: "UNRELATED", source: "FEMA" })}

                    />
                  )}

                  <DuplicateSection
                    title="Potential NFIP Benefits"
                    columns={benefitsColumns}
                    data={paginate(benefitsData.NFIP?.unrelated)}
                    showActions
                    actionLabel="Mark as Related"
                    onMarkDuplicate={(rows) => handleMarkRelated(rows, { status: "RELATED", source: "NFIP" })}
                    emptyComponent={(
                      <EmptyBenefitsState
                        title="No Potential NFIP Benefits"
                      />
                    )}
                  />

                  {benefitsData.NFIP?.related.length > 0 && (
                    <DuplicateSection
                      title="Confirmed NFIP Benefits"
                      columns={benefitsColumns}
                      data={paginate(benefitsData.NFIP?.related)}
                      actionLabel="Mark as Unrelated"
                      showActions
                      onMarkDuplicate={(rows) => handleMarkRelated(rows, { status: "UNRELATED", source: "NFIP" })}
                    />
                  )}

                  <div className="global-pagination">
                    <button
                      className="nav-btn"
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage((p) => p - 1)}
                    >
                      &lt; Back
                    </button>

                    <button
                      className="nav-btn"
                      disabled={!hasNextPage(benefitsPageData)}
                      onClick={() => setCurrentPage((p) => p + 1)}
                    >
                      Next &gt;
                    </button>
                  </div>
                </>
              )}

              {isDocumentAgent && (
                <>
                  <ReportLegend
                    title={`Document Quality Report: Application ${reportData?.caseRow?.caseId ?? 'N/A'}`}
                    legends={false}
                  />
                  <ReportSummary summary={reportData.summary} />

                  {/* APPLICATION DETAILS */}
                  <DuplicateSection
                    title="Application Details"
                    columns={documentCaseColumns}
                    data={paginate(reportData.caseRow ? [reportData.caseRow] : [])}
                  />

                  {/* DOCUMENT ISSUES */}
                  <DuplicateSection
                    title="Documents Requiring Correction"
                    columns={documentQualityColumns(setOpenDoc)}
                    data={paginatedCorrections}
                    onMarkDuplicate={handleMarkDocAcceptable}
                    showActions
                    actionLabel="Mark as Acceptable"
                  />
                  <DocumentViewerModal
                    fileUrl={openDoc?.fileUrl}
                    documentName={openDoc?.documentName}
                    onClose={() => setOpenDoc(null)}
                  />

                  <DuplicateSection
                    title="Acceptable Documents"
                    columns={documentQualityColumns(setOpenDoc)}
                    onMarkDuplicate={handleMarkDocNotAcceptable}
                    data={paginatedAcceptable}
                    showActions
                    actionLabel="Mark as not Acceptable"
                  />
                  <div className="global-pagination">
                    <button
                      className="nav-btn"
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage((p) => p - 1)}
                    >
                      &lt; Back
                    </button>

                    <button
                      className="nav-btn"
                      disabled={(currentPage * PAGE_SIZE) >= documentPageData.length}
                      onClick={() => setCurrentPage((p) => p + 1)}
                    >
                      Next &gt;
                    </button>
                  </div>

                </>
              )}
            </>
          )}

          <div className={`agent-panel-wrapper ${isAgentPanelOpen ? "open" : ""}`}>
            <IntakeAgentPanel
              userName="User"
              applicationCount={9}
              onRunDuplicateCheck={() => console.log("Run duplicate check")}
              onSaveForLater={() => console.log("Saved for later")}
              onClose={() => setIsAgentPanelOpen(false)}
              defaultMsg={defaultMsg}
              agentName={agentName}
              isReviewAgentScreen={isReviewAgentScreen}
              logedInUserMail={logedInUserMail}
              isAgentPanelOpen={isAgentPanelOpen}
            />
          </div>
          <ConfirmDialog
            open={openDialog}
            title="Set as Primary Application?"
            message="You already have a primary application. Setting this one as primary will replace the current primary application. Are you sure you want to continue?"
            onConfirm={handleDialogConfirm}
            onClose={handleDialogClose}
            color="primary" // You can change the button color here
          />
        </div>
      </div>
    </div>
  );
};
ReliefManScreen.propTypes = {
  logedInUserMail: PropTypes.string.isRequired,
};

export default ReliefManScreen;
